var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "21",
        height: "20",
        viewBox: "0 0 21 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_91_1939)" } }, [
        _c("path", {
          attrs: {
            d:
              "M20.2832 9.37336L10.9098 0L1.53638 9.37336L2.71904 10.556L10.9098 2.36534L19.1005 10.556L20.2832 9.37336Z"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M4.1984 11.63L10.9096 4.93977L17.6208 11.63V20H13.4183L13.4183 13.3098L8.40061 13.3098L8.40061 20H4.1984V11.63Z"
          }
        })
      ]),
      _vm._v(" "),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_91_1939" } }, [
          _c("rect", {
            attrs: {
              width: "20",
              height: "20",
              fill: "white",
              transform: "translate(0.536377)"
            }
          })
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }